<h1 mat-dialog-title class="dialog-title">
  @if (!uploadLoading) { Upload vaccination records } @else { Uploading vaccination records }
</h1>

@if (uploadLoading) {
<mat-dialog-content class="form-loader">
  <mat-spinner [diameter]="60" aria-label="Uploading files"></mat-spinner>
</mat-dialog-content>
}

<!-- Error Message -->
@if (uploadError && !uploadLoading) {
<mat-dialog-content>
  <div class="error-message" role="alert" aria-live="polite">
    <p class="error-text">{{ uploadError }}</p>
  </div>
</mat-dialog-content>
}

<!-- Form Content -->
@if (!uploadLoading) {
<mat-dialog-content class="form-container">
  @if (dogData && dogData.length > 0) { @for (dog of dogData; track dog.id; let last = $last) {
  <div class="vax-section">
    <h2 class="dog-name">{{ dog.name }}</h2>

    <input
      [id]="'file-input-' + dog.id"
      class="file-input-hidden"
      type="file"
      #fileInput
      accept="image/*,.pdf,image/heic,image/heif"
      (change)="onFileSelected($event, dog.id)"
      multiple
      [attr.aria-label]="'Upload files for ' + dog.name"
    />
    <label mat-raised-button class="upload-button" [attr.for]="'file-input-' + dog.id" tabindex="0" role="button">
      Upload file(s) for {{ dog.name }}
    </label>

    @if (dogFormData.get(dog.id)?.files; as files) {
    <div class="files-list">
      @for (file of files; track file.name) {
      <div class="file-item">
        <span class="file-name" [title]="file.name">{{ file.name }}</span>
        <button
          mat-raised-button
          (click)="onRemoveFile($event, file, dog.id)"
          type="button"
          [attr.aria-label]="'Remove ' + file.name"
        >
          Remove
        </button>
      </div>
      }
    </div>
    }
  </div>

  @if (!last && dogData.length > 1) {
  <hr class="divider" />
  } } }
</mat-dialog-content>
} @if (!uploadLoading) {
<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    class="submit-button"
    [disabled]="disableUploadButton || uploadLoading"
    (click)="onSubmit($event)"
    type="button"
    aria-label="Upload vaccination records"
  >
    Upload
  </button>
  <button mat-raised-button mat-dialog-close type="button" class="close-button" aria-label="Close dialog">Close</button>
</mat-dialog-actions>
}
